'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
function $f_sr_EnumValue__productElement__I__O($thiz, n) {
  throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), ("" + n));
}
export { $f_sr_EnumValue__productElement__I__O as $f_sr_EnumValue__productElement__I__O };
